import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {
    getInterpsShortName,
    transformInterpToCSSClass,
} from '../../../common/utils/studentsListHelpers';
import { INTERPRETATIONS } from '../../../constants/interpretations';
import Button from '../../button/Button';
import { navigateToTRCDetails } from '../../../common/navigation/navigation';
import HyphenIcon from '../hyphen-icon/HyphenIcon';
import { localize } from '../../../common/localization';

const TRCDetails = ({
    finalLevel,
    interp,
    bookGenre,
    overallPerf,
    isPresumed,
    hasMultipleResults,
    navigationDetails,
    accessLink,
    displayOfficialnessPopup,
    displayDeletePresumedResultPopup,
    displayTRCOutsideBMPopup,
}) => {
    const interpsShortName = getInterpsShortName(interp);
    const interpsCssClass = transformInterpToCSSClass(
        interpsShortName || INTERPRETATIONS.NO_INTERPRETATION,
    );
    const bookPerformance = overallPerf + (hasMultipleResults ? '*' : ' ');
    const cssClasses = classNames(
        // HACK: empty string is added for correct prefixing
        // issue https://github.com/vezetvsem/react-classname-prefix-loader/issues/3
        'dashboard-trc-details',
        'dashboard-' + interpsCssClass,
    );

    const getScoreContainer = () => {
        switch (interpsShortName) {
            case INTERPRETATIONS.PAUSED:
                return (
                    <div className='dashboard-pause'>
                        <div className='dashboard-vertical-line' />
                        <div className='dashboard-vertical-line' />
                    </div>
                );
            case INTERPRETATIONS.UNKNOWN:
                return <HyphenIcon />;
            default:
                return (
                    <>
                        {finalLevel && (
                            <div className='dashboard-level'>
                                <strong>{finalLevel}</strong>
                                {isPresumed ? (
                                    <sup className='dashboard-book-genre'>PS</sup>
                                ) : (
                                    <sup className='dashboard-book-genre'>{bookGenre}</sup>
                                )}
                            </div>
                        )}
                        <div className='dashboard-book-performance'>{bookPerformance.trim()}</div>
                    </>
                );
        }
    };

    const getScoreInerpretation = () => {
        switch (interpsShortName) {
            case INTERPRETATIONS.UNKNOWN:
                return <HyphenIcon />;
            case INTERPRETATIONS.PAUSED:
                return <div className='dashboard-paused-label'>{localize(interpsShortName)}</div>;
            default:
                return <div className='dashboard-interpretation'>{localize(interpsShortName)}</div>;
        }
    };

    const getDetailsBody = () => (
        <>
            {getScoreContainer(interpsShortName, finalLevel)}
            {interpsShortName && getScoreInerpretation(interpsShortName)}
        </>
    );

    return navigationDetails ||
        accessLink ||
        displayOfficialnessPopup ||
        displayDeletePresumedResultPopup ||
        displayTRCOutsideBMPopup ? (
        <Button
            cssClasses={cssClasses}
            onClick={
                displayOfficialnessPopup ||
                displayDeletePresumedResultPopup ||
                displayTRCOutsideBMPopup ||
                navigateToTRCDetails(navigationDetails, accessLink)
            }
        >
            {getDetailsBody()}
        </Button>
    ) : (
        <div className={cssClasses}>{getDetailsBody()}</div>
    );
};

TRCDetails.propTypes = {
    finalLevel: PropTypes.string,
    interp: PropTypes.string,
    bookGenre: PropTypes.string,
    overallPerf: PropTypes.string.isRequired,
    isPresumed: PropTypes.bool,
    hasMultipleResults: PropTypes.bool,
    navigationDetails: PropTypes.shape({
        studentId: PropTypes.string.isRequired,
        period: PropTypes.string.isRequired,
        classeId: PropTypes.string.isRequired,
    }),
    accessLink: PropTypes.string,
    displayOfficialnessPopup: PropTypes.func,
    displayDeletePresumedResultPopup: PropTypes.func,
    displayTRCOutsideBMPopup: PropTypes.func,
};

TRCDetails.defaultProps = {
    navigationDetails: undefined,
    interp: null,
    bookGenre: null,
    accessLink: null,
    finalLevel: null,
    isPresumed: false,
    hasMultipleResults: false,
    displayOfficialnessPopup: null,
    displayDeletePresumedResultPopup: null,
    displayTRCOutsideBMPopup: null,
};

export default TRCDetails;
